/* global StackDiscounts */
/* global bundleVariants */
import {addToCart} from "./mini-cart";
import {documentEventDispatcher, EVENT_SHOW_QUANTITY_UPSELL} from "./eggo-cart-events";
import {EVENT_BUNDLE_VARIATION_CLICKED} from "../product-events";
import {registerVariantColorsCard} from "./product-card";

const CLASS_JS = "is-js";
const STRATEGY_123 = "strategy-123";
const STRATEGY_MULTI = "strategy-multi";
const STRATEGY_BUNDLE = "strategy-bundle";
const SELECTED_VARIATION = "selected";
const DISABLE_ADD_TO_CART = "disable";

document.addEventListener("DOMContentLoaded", function () {
    const isProductPage = document.querySelector(".eggo-product");
    reviewSlider();
    if (!isProductPage) return;

    setProductRating();
    productTabs();
    variantSelector();
    inputQuantity();
    productSingleAddToCart();
    offerSelector();
    offerSelector123();
    offerBundle();
    eggoUpsellContainer();
    packageResponsive();
    squizzProducts();
    fixedAddToCart();
    fixedAddToCartGoUp();
    fixedAddToCartAction();
    productFixedVideo();
    currentlyWatching();
});

const currentlyWatching = () => {
    const CWS = document.querySelectorAll(".currently-watching");
    if (!CWS.length) return;
    const firstCW = CWS[0];
    const info = firstCW.querySelector(".currently-watching__info");
    if (!info) return;
    const minNumber = info.dataset.showAnalytics;
    const maxNumber = info.dataset.showMax;
    if (!minNumber || !maxNumber) return;
    const rand = parseInt(minNumber) + Math.floor(Math.random() * (parseInt(maxNumber) - parseInt(minNumber)));

    CWS.forEach(CW => {
        const numberElement = CW.querySelector(".currently-watching__number-inner");
        if (!numberElement) return;
        numberElement.innerHTML = rand;
        numberElement.classList.remove("loading");
    });
}

const setProductRating = () => {
    const productRatings = document.querySelectorAll(".eggo-stars");
    productRatings.forEach((productRating) => {
        const badge = productRating.querySelector(".stamped-badge-caption");
        const finalRatingElement = productRating.querySelector(".eggo-product__rating-final-total");
        const colorRatingElement = productRating.querySelector(".eggo-stars-percentage-color");
        const eggoBadge = productRating.querySelector("#eggo-badge");

        if (!badge) {
            productRating.remove();
            return;
        }

        const rating = badge.dataset.rating;
        const ratingExtra = rating / 5 * 2;
        const ratingPercentage = "calc(" + (rating / 5 * 100) + "% + " + ratingExtra + "px)";

        let numberOfReviews = badge.dataset.reviews;

        if (eggoBadge) {
            const reviewCount = eggoBadge.dataset.reviewCount;
            if (reviewCount) {
                numberOfReviews = parseInt(reviewCount);
            }
        }

        const countString = numberOfReviews > 4 ? stringReviews["more"] : stringReviews[numberOfReviews];
        if (finalRatingElement) finalRatingElement.innerHTML = `<span class="eggo-product__rating-final-total">${numberOfReviews} ${countString}</span>`;
        colorRatingElement.style.width = ratingPercentage;
    })
}

const productTabs = () => {
    const tabs = document.querySelector(".eggo-product__info-tabs");
    if (!tabs) return;

    const tabElements = document.querySelectorAll(".eggo-product__info-tab");
    tabElements.forEach((tab) => {
        tab.addEventListener("click", function () {
            const tabGroup = this.dataset.toggleGroup;
            const tabId = this.dataset.show;
            if (tab.classList.contains("checked")) {
                tab.classList.remove("checked");
                if (tabGroup !== "rest-tabs") return;
                return tab.parentNode.querySelector(".eggo-product__info-tab-content").classList.remove("checked");
            }
            toggleTabs(tabs.querySelectorAll(`[data-group='${tabGroup}']`));
            toggleTabs(tabs.querySelectorAll(`[data-toggle-group='${tabGroup}']`));
            tabs.querySelector(`[data-tab-content='${tabId}']`).classList.add("checked");
            tab.classList.add("checked");
        });
    })
}

const toggleTabs = (elements) => {
    elements.forEach((tab) => tab.classList.remove("checked"));
}

const variantSelector = () => {
    const variants = document.querySelectorAll(".eggo-product__variant-selector .product-card__variant-element");
    const mainOfferVariants = document.querySelectorAll(".eggo-product__info-offer--main .product-card__variant-color");
    const currentPriceContainer = document.querySelector(`.eggo-product__info-offer--main .product-card__price--current-value`);
    const addToCartButton = document.querySelector(".eggo-product__info-add-to-cart .is-add-to-cart");
    const fakeAddToCartButton = document.querySelector(".eggo-product__info-add-to-cart div.eggo-button--buy");
    multiVariant123NoStockLogic(addToCartButton, fakeAddToCartButton);

    /** Product out of stock check */
    if (mainOfferVariants.length) {
        mainOfferVariants.forEach((mainVariant) => {
            if (mainVariant.classList.contains(SELECTED_VARIATION)) variantNoStockLogic(mainVariant, addToCartButton, fakeAddToCartButton);
        })
    }

    variants.forEach(variant => {
        variant.addEventListener("click", () => {
            if (!variant.classList.contains("group-variation")) {
                if (variant.classList.contains('bundle-variation')) {
                    const currentGroupVariants = variant.parentNode.querySelectorAll(".bundle-variation");
                    currentGroupVariants.forEach(variant => variant.classList.remove(SELECTED_VARIATION));
                    variant.classList.add(SELECTED_VARIATION);
                    const variation = toggleBundleAddToCartButton(document.querySelector(".add-to-cart-basic .eggo-product__variant-selector"), addToCartButton);
                    if(variation){
                        documentEventDispatcher(EVENT_BUNDLE_VARIATION_CLICKED, variation);
                    }
                } else {
                    variants.forEach(variant => variant.classList.remove("selected"));
                    variant.classList.add("selected");
                    variantNoStockLogic(variant, addToCartButton, fakeAddToCartButton);
                }
            } else {
                /** VARIATIONS 123 **/
                const currentGroupVariants = variant.parentNode.querySelectorAll(".group-variation");
                currentGroupVariants.forEach(variant => variant.classList.remove("selected"));
                variant.classList.add("selected");
                multiVariant123NoStockLogic(addToCartButton, fakeAddToCartButton);
            }
            setAddToCartVariation(variant.dataset.variationId);
            if (!variant.classList.contains("product-card__variant-color--gift")) return;
            currentPriceContainer.innerHTML = variant.dataset.price;
        });
    })
}

const multiVariant123NoStockLogic = (addToCartButton, fakeAddToCartButton) => {
    const variantContainer = document.querySelector(".eggo-product__info-additional-offer-123.checked");
    if (!variantContainer) return;
    const variantsOutOfStock = variantContainer.querySelectorAll("." + SELECTED_VARIATION + ".notavailable");
    if (variantsOutOfStock.length) {
        if (addToCartButton) addToCartButton.classList.add("hide-this");
        if (fakeAddToCartButton) fakeAddToCartButton.classList.remove("hide-this");
    } else {
        if (addToCartButton) addToCartButton.classList.remove("hide-this");
        if (fakeAddToCartButton) fakeAddToCartButton.classList.add("hide-this");
    }
}

const variantNoStockLogic = (variant, addToCartButton, fakeAddToCartButton) => {
    if (variant.classList.contains("notavailable")) {
        if (addToCartButton) addToCartButton.classList.add("hide-this");
        if (fakeAddToCartButton) fakeAddToCartButton.classList.remove("hide-this");
    } else {
        if (addToCartButton) addToCartButton.classList.remove("hide-this");
        if (fakeAddToCartButton) fakeAddToCartButton.classList.add("hide-this");
    }
}
const setAddToCartVariation = (variationId) => {
    const addToCartButton = document.querySelector(".eggo-product__info-add-to-cart .is-add-to-cart.eggo-button--buy");
    addToCartButton.dataset.variation = variationId;
}

const inputQuantity = () => {
    const inputValue = document.querySelector(".eggo-product__info-quantity-input-input");
    const inputValuePlus = document.querySelector(".eggo-product__info-quantity-input-plus");
    const inputValueMinus = document.querySelector(".eggo-product__info-quantity-input-minus");

    if (inputValuePlus) {
        inputValuePlus.addEventListener("click", () => {
            inputValue.stepUp(1);
            eggoUpsellContainer();
        })
    }

    if (inputValueMinus) {
        inputValueMinus.addEventListener("click", () => {
            inputValue.stepDown(1);
            eggoUpsellContainer();
        })
    }

    document.addEventListener(EVENT_SHOW_QUANTITY_UPSELL, () => eggoUpsellContainer());
}

const productSingleAddToCart = () => {
    const productInfo = document.querySelector(".eggo-product__info");
    const quantity = productInfo.querySelector(".eggo-product__info-quantity-input-input");
    const addToCartButton = productInfo.querySelector(".eggo-product__info-add-to-cart .is-add-to-cart.eggo-button--buy");
    if (!addToCartButton) return;
    addToCartButton.addEventListener("click", function (e) {
        e.preventDefault();
        if (addToCartButton.classList.contains(STRATEGY_MULTI)) {
            const productElements = document.querySelectorAll(".eggo-product__info-offer--main .product-card__variant-color." + SELECTED_VARIATION);
            const productElementsQuantity = document.querySelector(".eggo-product__info-offer--main .eggo-product__info-quantity-input-input")
            addSelectedColorsToCart(productElements);
            if (productElementsQuantity) productElementsQuantity.value = 1;
            eggoUpsellContainer();

        } else if (addToCartButton.classList.contains(STRATEGY_123)) {
            const checkedChoice = document.querySelector(".eggo-product__info-additional-offer-123.checked");
            if (!checkedChoice) return;
            const checkedColors = checkedChoice.querySelectorAll(".product-card__variant-color." + SELECTED_VARIATION);
            addSelectedColorsToCart(checkedColors);
        } else if (addToCartButton.classList.contains(STRATEGY_BUNDLE)) {
            bundleVariationLogic(document.querySelector(".add-to-cart-basic .eggo-product__variant-selector"), quantity.value);
        } else {
            addToCart([{
                id: this.dataset.variation,
                quantity: quantity.value
            }]);
        }
    });
}

const addSelectedColorsToCart = (domColors) => {
    if (!domColors.length) return;
    const productIds = Array.from(domColors).reduce((ids, element) => {
        if (ids?.[element.dataset.variationId]) {
            ids[element.dataset.variationId].quantity++;
        } else {
            ids[element.dataset.variationId] = {
                id: element.dataset.variationId,
                quantity: 1
            };
        }
        return ids;
    }, {})
    addToCart(Object.values(productIds));
}


const offerSelector = () => {
    const offers = document.querySelectorAll(".add-to-cart-basic .eggo-product__info-offer");
    const allVariations = document.querySelectorAll(".add-to-cart-basic .eggo-product__info .product-card__variant-color");
    const addToCartButton = document.querySelector(".add-to-cart-basic .eggo-product__info-add-to-cart .is-add-to-cart");
    const fakeAddToCartButton = document.querySelector(".add-to-cart-basic .eggo-product__info-add-to-cart div.eggo-button--buy");
    if (offers.length === 0) return;
    offers.forEach(offer => {
        offer.addEventListener("click", () => {
            if (offer.classList.contains("checked")) return;
            const variations = offer.querySelectorAll(".product-card__variant-color");
            offers.forEach(innerOffer => innerOffer.classList.remove("checked"));
            if (variations.length !== 0) {
                allVariations.forEach(allSingleVariation => allSingleVariation.classList.remove(SELECTED_VARIATION));
                variations[0].classList.add(SELECTED_VARIATION);
                setAddToCartVariation(variations[0].dataset.variationId);
                variantNoStockLogic(variations[0], addToCartButton, fakeAddToCartButton);
            }
            if (offer.classList.contains("eggo-product__info-additional-offer")) {
                const buyButton = document.querySelector(".eggo-button--buy.strategy-multi");
                if (buyButton) buyButton.classList.remove(STRATEGY_MULTI);
            } else {
                const mainOfferInput = document.querySelector(".eggo-product__info-offer--main .eggo-product__info-quantity-input-input");
                if (mainOfferInput) mainOfferInput.value = 1;
                eggoUpsellContainer();
            }
            offer.classList.add("checked");
        });
    });
}

const offerSelector123 = () => {
    const offers = document.querySelectorAll(".add-to-cart-123 .eggo-product__info-offer");
    if (offers.length === 0) return;
    const addToCartButton = document.querySelector(".eggo-product__info-add-to-cart .is-add-to-cart");
    const fakeAddToCartButton = document.querySelector(".eggo-product__info-add-to-cart div.eggo-button--buy");
    if (!addToCartButton) return;

    addToCartButton.classList.add(STRATEGY_123);
    offers.forEach(offer => {
        offer.addEventListener("click", () => {
            if (offer.classList.contains("checked")) return;
            offers.forEach(innerOffer => innerOffer.classList.remove("checked"));
            offer.classList.add("checked");
            multiVariant123NoStockLogic(addToCartButton, fakeAddToCartButton);
        })
    })
}

const eggoUpsellContainer = async () => {
    const upsellMessages = document.querySelector(".eggo-product__info-offer--main .eggo-product__upsell-messages");
    const inputQuantity = document.querySelector(".eggo-product__info-offer--main .eggo-product__info-quantity-input-input");
    if (!upsellMessages) return;
    const upsellMessageContainer = document.querySelector(".eggo-product__info-offer--main .eggo-product__upsell-message-container");
    const currentPriceContainer = document.querySelector(`.eggo-product__info-offer--main .product-card__price--current:not(.${CLASS_JS})`);
    const variantSelectorContainer = document.querySelector(".eggo-product__info-offer--main .product-card__variant-colors");
    const addToCartButton = document.querySelector(".eggo-product__info-add-to-cart .is-add-to-cart");

    const parseUpsellData = upsellMessages.dataset.quantityUpsell;
    const productId = parseInt(upsellMessages.dataset.productId);
    if (!parseUpsellData) return;
    const upsellDataRaw = JSON.parse(parseUpsellData);
    if (upsellDataRaw.length === 0) return;
    const upsellData = upsellDataRaw.reduce((final, upsell) => {
        const data = upsell.split(":");
        final[data[0]] = data;
        return final;
    }, {});
    updateUpsellBadge(upsellData, productId, upsellMessageContainer, currentPriceContainer, variantSelectorContainer, addToCartButton, parseInt(inputQuantity.value));
}

const transformTags = (string) => {
    string = string.replace(/\[b\]/, "<strong>");
    string = string.replace(/\[\/b\]/, "</strong>");
    return string;
}
const updateUpsellBadge = (upsellData, productId, messageElement, priceElement, variantElement, addToCartButton, selectedQuantity) => {
    const MESSAGE_INDEX = 1
    const COLOR_INDEX = 2;
    const PRICE_INDEX = 3;
    const BADGE_INDEX = 4;


    if (upsellData?.[selectedQuantity]) {
        const qtyUpsellData = upsellData[selectedQuantity];

        /** RESET **/
        priceElement.classList.remove("product-card__price--regular");
        const priceDoubleDiscount = document.querySelector(`.product-card__price--current.${CLASS_JS}`);
        if (priceDoubleDiscount) priceDoubleDiscount.remove();
        const discountBadge = document.querySelector(`.small-discount-badge.${CLASS_JS}`);
        if (discountBadge) discountBadge.remove();
        addToCartButton.classList.remove(STRATEGY_MULTI);

        if (variantElement) {
            generateVariants(variantElement, selectedQuantity);
            addToCartButton.classList.add(STRATEGY_MULTI);
        }

        /** END RESET **/
        if (qtyUpsellData?.[COLOR_INDEX]) {
            const color = qtyUpsellData[COLOR_INDEX];
            messageElement.classList.remove("message-green");
            messageElement.classList.remove("message-red");
            messageElement.classList.add(`message-${color}`);
        }

        if (qtyUpsellData?.[BADGE_INDEX]) {
            priceElement.parentNode.append(createBadgeElement(qtyUpsellData?.[BADGE_INDEX]));
        }

        if (qtyUpsellData?.[PRICE_INDEX]) {
            priceElement.classList.add("product-card__price--regular");
            priceElement.parentNode.append(createPriceElement(qtyUpsellData[PRICE_INDEX]));
        }

        messageElement.innerHTML = transformTags(qtyUpsellData[MESSAGE_INDEX]);
        messageElement.classList.remove("hide-this");

    } else {
        messageElement.classList.add("hide-this");
    }
}

const createPriceElement = (value) => {
    const element = document.createElement("span");
    element.classList.add("product-card__price--current");
    element.classList.add(CLASS_JS);
    element.innerHTML = value;
    return element;
}

const createBadgeElement = (value) => {
    const element = document.createElement("span");
    element.classList.add("small-discount-badge");
    element.classList.add("small-discount-badge--green");
    element.classList.add(CLASS_JS);
    element.innerHTML = value;
    return element;
}

const createVariantSelectorElement = (value, index) => {
    const element = document.createElement("div");
    element.classList.add("product-card__variant-colors");
    element.classList.add("product-card__variant-colors--" + index);

    element.classList.add(CLASS_JS)
    element.innerHTML = value;
    return element;
}

const generateVariants = (variantSelector, quantity) => {
    const allVariantSelectors = document.querySelectorAll(".eggo-product__info-offer.eggo-product__info-offer--main .product-card__variant-colors");
    if (allVariantSelectors.length < quantity) {
        /** Add new selector **/
        variantSelector.parentNode.append(createVariantSelectorElement(variantSelector.innerHTML, quantity - 1));
        registerVariantColorsCard(`.product-card__variant-colors--${quantity - 1}.${CLASS_JS} .product-card__variant-color`);

    } else {
        /** Remove last selector **/
        if (allVariantSelectors.length > 1 && allVariantSelectors.length !== quantity) {
            variantSelector.parentNode.lastChild.remove();
        }
        if (quantity === 1) {
            const restElements = variantSelector.parentNode.querySelectorAll(`.${CLASS_JS}`);
            restElements.forEach(element => element.remove());
        }
    }

}

const packageResponsive = () => {
    const checkPackageLayout = () => {
        packageContainers.forEach((packageContainer) => {
            const addToCart = packageContainer.querySelector(".is-add-to-cart");
            const contentSection = packageContainer.querySelector(".eggo-section-product__card-content");
            if (vw <= 767) {
                if (contentSection.querySelector(".is-add-to-cart")) {
                    addToCart.remove();
                    packageContainer.append(addToCart);
                }
            } else {
                if (!contentSection.querySelector(".is-add-to-cart")) {
                    addToCart.remove();
                    contentSection.append(addToCart);
                }
            }
        });
    }


    let vw = getViewportWidth();
    const packageContainers = document.querySelectorAll(".eggo-section-product__card-cols");
    if (!packageContainers.length) return;
    checkPackageLayout();

    window.addEventListener("resize", () => {
        vw = getViewportWidth();
        checkPackageLayout();
    })
}

const getViewportWidth = () => {
    return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
}

const squizzProducts = () => {
    const sliders = document.querySelectorAll(".squizz-products");
    if (sliders.length === 0) return;
    new Swiper('.squizz-products', {
        spaceBetween: 12,
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            200: {
                slidesPerView: 1,
                spaceBetween: 12
            },
            410: {
                slidesPerView: 2,
                spaceBetween: 12
            },
            650: {
                slidesPerView: 3,
                spaceBetween: 12
            },
            1025: {
                slidesPerView: 4
            }
        }
    });
}

const reviewSlider = () => {
    const sliders = document.querySelectorAll(".eggo-product-reviews__cards-slider");
    if (sliders.length === 0) return;
    new Swiper('.eggo-product-reviews__cards-slider', {
        spaceBetween: 16,
        slidesPerView: 1,
        allowTouchMove: false,
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            380: {
                slidesPerView: 2
            },
            769: {
                slidesPerView: 3
            }
        }
    });
}

const fixedAddToCart = () => {
    const wrapper = document.querySelector(".eggo-product__fixed-add-to-cart");
    if (!wrapper) return;
    const priceElement = document.querySelector(".eggo-product__info-add-to-cart");
    if (!priceElement) return;
    let windowTop = window.scrollY;
    let priceElementTop = priceElement.offsetTop + priceElement.offsetHeight;
    if (!wrapper) return;
    fixedAutoCartScrollPosition(wrapper, priceElementTop, windowTop);

    window.addEventListener("scroll", () => {
        if ((Math.abs(windowTop - window.scrollY) < 32)) return;
        windowTop = window.scrollY;
        fixedAutoCartScrollPosition(wrapper, priceElementTop, windowTop);
    });
}

const fixedAddToCartGoUp = () => {
    const button = document.querySelector(".eggo-product__go-up");
    if (!button) return;

    button.addEventListener("click", () => {
        window.scrollTo(0, 0);
    })
}


const fixedAutoCartScrollPosition = (wrapper, priceElementTop, windowTop) => {
    if (windowTop > priceElementTop) {
        if (!wrapper.classList.contains("visible")) {
            wrapper.classList.add("visible");
            document.body.classList.add("product-floating-cart-visible");
        }
    } else {
        if (wrapper.classList.contains("visible")) {
            wrapper.classList.remove("visible");
            document.body.classList.remove("product-floating-cart-visible");
        }
    }
}

const fixedAddToCartAction = () => {
    const button = document.querySelector(".eggo-product__fixed-add-to-cart .is-add-to-cart");
    const mainAddToCartButton = document.querySelector(".eggo-product__info-add-to-cart .is-add-to-cart");
    const offer = document.querySelector(".eggo-product__info-offer");
    if (!button || !mainAddToCartButton) return;

    button.addEventListener("click", (e) => {
        e.preventDefault();
        if (mainAddToCartButton.dataset.variation && !mainAddToCartButton.classList.contains("hide-this")) {
            mainAddToCartButton.click()
        } else {
            if (offer) {
                window.scrollTo(0, offer.offsetTop - 24);
            }
        }
    })
}

const productFixedVideo = () => {
    const productVideo = document.querySelector(".eggo-product-video");
    if (!productVideo) return;
    const buttonClose = productVideo.querySelector(".eggo-product-video__close");
    const video = productVideo.querySelector("video");
    const videoClickTap = (e) => {
        e.preventDefault();
        productVideo.classList.toggle("eggo-product-video--large");
        video.muted = false;
    };

    if (buttonClose) buttonClose.addEventListener("click", () => {
        productVideo.remove();
    })

    if (video) {
        video.addEventListener("click", videoClickTap);
    }
}

const offerBundle = () => {
    const offerBundle = document.querySelector('.eggo-product__variant-selector-special');
    const addToCartButton = document.querySelector(".eggo-product__info-add-to-cart .is-add-to-cart");
    if (offerBundle && addToCartButton) {
        addToCartButton.classList.add(STRATEGY_BUNDLE);
        const isVariationSelected = getBundleVariation(addToCartButton);
        if (!isVariationSelected) addToCartButton.classList.add(DISABLE_ADD_TO_CART);
    }
}

export const getBundleVariation = (addToCartBlock) => {
    if (typeof bundleVariants === "undefined") return;
    if (!addToCartBlock) return;
    const selectedElements = addToCartBlock.querySelectorAll(".product-card__variant-element." + SELECTED_VARIATION);
    if (!selectedElements) return;
    const selectedVariationString = Array.from(selectedElements).reduce((variantString, element) => {
        variantString += element.dataset.optionValue;
        return variantString;
    }, '');
    if (!bundleVariants?.[selectedVariationString]) return;
    return bundleVariants[selectedVariationString];
}

const bundleVariationLogic = (addToCartBlock, quantity) => {
    const variant = getBundleVariation(addToCartBlock);
    if (variant) {
        addToCart([{
            id: variant.id,
            quantity: quantity
        }]);
    }
}

const toggleBundleAddToCartButton = (addToCartBlock, addToCartButton) => {
    if (!addToCartBlock || !addToCartButton) return;
    const variation = getBundleVariation(addToCartBlock);
    if (variation) {
        addToCartButton.classList.remove(DISABLE_ADD_TO_CART);
        return variation;
    } else {
        addToCartButton.classList.add(DISABLE_ADD_TO_CART);
    }
    return false;
}

